import React, { useState } from 'react';
import Modal from './Modal';
import { toast } from 'react-hot-toast';

const FolderModal = ({ 
  isOpen, 
  onClose, 
  onSubmit, 
  folder = null, 
  title = 'Create Folder' 
}) => {
  const [name, setName] = useState(folder?.name || '');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showFolderModal, setShowFolderModal] = useState(false);
  const [editingFolder, setEditingFolder] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      toast.error('Please enter a folder name');
      return;
    }

    setIsSubmitting(true);
    try {
      await onSubmit(name);
      onClose();
    } catch (error) {
      console.error('Error submitting folder:', error);
      toast.error('Failed to save folder');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">{title}</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label 
              htmlFor="folderName" 
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Folder Name
            </label>
            <input
              type="text"
              id="folderName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#04b53a] focus:border-[#04b53a]"
              placeholder="Enter folder name"
              autoFocus
            />
          </div>

          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#04b53a]"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              className="px-4 py-2 text-sm font-medium text-white bg-[#04b53a] border border-transparent rounded-md hover:bg-[#039431] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#04b53a] disabled:opacity-50"
            >
              {isSubmitting ? 'Saving...' : 'Save'}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default FolderModal; 